import React from 'react';
import { Modal, Row, Col, Input, Button, Spin, Radio } from 'antd';
import API_URL from '../../common/url';
import AjaxRequest from '../../common/AjaxRequest';
import UserSearchInput from './UserSearchInput';
import UserDetail from '../user/UserDetail';
import MoreConditionUser from './MoreConditionUser';
import TransferPro from "./TransferPro";
import Text from '../basicElement/Text';
import './css/list.less';

const InputGroup = Input.Group;
const RadioGroup = Radio.Group;
const confirm = Modal.confirm;

class SetPA extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            investigationId: '',
            investigation: {},
            list: [],
            pmaList: [],
            selectUser: {},
            loading: false,
            rerender: false,
        };
    }


    show = (id, curRole) => {
        this.setState({
            curRole,
            visible: true,
            investigationId: id,
        }, () => {
            this.loadModalData();
        });
    }

    loadModalData = () => {
        const { investigationId } = this.state;
        this.setState({ loading: true });
        const options = {
            url: `${API_URL.execute.view}`,
            data: {
                investigationId,
            },
            dataType: 'json',
            doneResult: data => {
                const investigation = data.data.investigation;
                const { curRole } = this.state;
                let list = [];
                let pmaList = [];
                if (curRole === 'PA' || curRole === 'PMA') {
                    list = (investigation.paUserList || []).map(user => ({
                        value: user.userId,
                        text: `${user.userName}(${user.employeeCode})`,
                    }));
                    pmaList =  (investigation.pmaList || []).map(user => ({
                        value: user.userId,
                        text: `${user.userName}(${user.employeeCode})`,
                    }));
                } else {
                    list = (investigation.bdUserList || []).map(user => ({
                        value: user.userId,
                        text: `${user.userName}(${user.employeeCode})`,
                    }));
                }
                this.setState({
                    list,
                    pmaList,
                    investigation,
                    loading: false,
                });
            }, errorResult: () => {
                this.setState({ loading: false });
            },
        };
        AjaxRequest.sendRequest(options);
    }

    hide = () => {
        this.setState({
            visible: false,
            rerender: true,
            selectUser: {},
        }, () => {
            this.setState({
                rerender: false,
            });
        })
    }

    addFromCondition = (role, addList = []) => {
        const { curRole, investigationId } = this.state;
        let idx = 0;
        const userParams = {};
        this.setState({ loading: true });

        addList.map(user => {
            userParams['users[' + idx + '].roleCode'] = curRole;
            userParams['users[' + idx + '].userId'] = user.value;
            idx++;
        });

        const options = {
            url: API_URL.investigation.addMember,
            data: {
                investigationId,
                ...userParams,
            },
            dataType: 'json',
            doneResult: () => {
                this.setState({ loading: false }, () => {
                    this.loadModalData();
                });
            }, errorResult: () => {
                this.setState({ loading: false });
            },
        };
        AjaxRequest.sendRequest(options);
    }

    getPASource = () => {
        const { list, curRole } = this.state;
        return (
            <div>
                {
                    (list || []).map(user => (
                        <Row key={user.value}>
                            <Col span={20}>
                                <span>
                                    <a onClick={() => this.viewUser(user.value)}>{user.text}</a>
                                </span>
                            </Col>
                            <Col span={2}>
                                <Button type="primary" shape="circle" icon="close" size='small' onClick={this.removeUser.bind(this, user.value, curRole)} />
                            </Col>
                            <Col span={2}>
                                {
                                    (curRole === 'PA' || curRole === 'PMA') &&
                                    <div style={{ color: "#fff", marginTop: "3px", cursor: "pointer", backgroundColor: "#fdaf32", borderRadius: "9px", width: "18px", height: "18px", lineHeight: "18px", textAlign: "center" }}>
                                        <i style={{ fontSize: "14px" }} onClick={this.transferPro.bind(this, user, curRole)} className="icon iconfont">&#xe62a;</i>
                                    </div>
                                }
                            </Col>
                        </Row>
                    ))
                }
            </div>
        );
    }

    getPMASource = () => {
        const { pmaList } = this.state;
        return (
            <div>
                {
                    (pmaList || []).map(user => (
                        <Row key={user.value}>
                            <Col span={20}>
                                <span>
                                    <a onClick={() => this.viewUser(user.value)}>{user.text}</a>
                                </span>
                            </Col>
                            <Col span={2}>
                                <Button type="primary" shape="circle" icon="close" size='small' onClick={this.removeUser.bind(this, user.value, 'PMA')} />
                            </Col>
                        </Row>
                    ))
                }
            </div>
        );
    }

    viewUser = userId => {
        this.userDetailRef.show(userId);
    }

    handleSelectUser = value => {
        this.setState({ selectUser: value });
    }

    onAddUser = () => {
        const { curRole, selectUser = {}, investigationId } = this.state;
        console.log(selectUser);
        if (!selectUser.value) {
            return;
        }
        this.setState({ loading: true });

        let userParams = '';
        userParams += 'users[0].userId=' + selectUser.value;
        userParams += '&users[0].roleCode=' + curRole;
        const options = {
            url: `${API_URL.investigation.addMember}` + '?' + userParams,
            data: {
                investigationId,
            },
            dataType: 'json',
            doneResult: () => {
                this.setState({ loading: false }, () => {
                    this.loadModalData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        AjaxRequest.sendRequest(options);
    }

    removeUser = (value, role) => {
        const { investigationId, list } = this.state;
        if (role == "BD") {
            if ((list || []).length <= 1) {
                Modal.error({ title: "BD为必填，无法删除最后一个BD" });
                return;
            }
        }
        const options = {
            url: `${API_URL.investigation.deleteMember}`,
            data: {
                investigationId,
                userId: value,
                roleCode: role
            },
            dataType: 'json',
            doneResult: data => {
                if (data.error) {
                    Modal.error({ title: data.error });
                    return;
                }
                this.setState({ loading: false }, () => {
                    this.loadModalData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        confirm({
            title: '确定删除该人员吗?',
            onOk: () => {
                this.setState({ loading: true });
                AjaxRequest.sendRequest(options);
            },
        });
    }

    transferPro = (user, roleCode) => {
        this.transferProRef.show(user, roleCode);
    }

    moreUser = () => {
        this.moreUserRef.show('');
    }

    onAddRoleChange = (e) => {
        this.setState({
            curRole: e.target.value
        })
    }


    render() {
        const { visible, investigation, loading, rerender, investigationId, curRole } = this.state;
        return (
            <div>
                <Modal
                    title={`${(curRole === 'PA' || curRole === 'PMA') ? '配置PA和协助项目成员' : '配置BD' }`}
                    visible={visible}
                    onCancel={this.hide}
                    className="create-modal delegate-modal"
                    wrapClassName="vertical-center-modal"
                    width={550}
                    footer={[
                        <Button key="back" size="large" onClick={this.hide}>关闭</Button>,
                    ]}
                >
                    <Spin spinning={loading}>
                        <div className="set_role_users" style={{ height: "250px" }}>
                            <div style={{ height: "200px", overflowY: "auto" }}>
                                <Row>
                                    <Col span={6}>项目简称</Col>
                                    <Col span={1} />
                                    <span style={{
                                        whiteSpace: 'break-spaces',
                                        display: 'inline-block',
                                        width: '70%',
                                    }}>{investigation.investigationName}</span>
                                </Row>
                                <Row>
                                    <Col span={6}>项目编号：</Col>
                                    <Col span={1} />
                                    <Col>{investigation.investigationCode}</Col>
                                </Row>
                                <Row>
                                    <Col span={6} style={{ marginTop: 10 }}>
                                        <Text editable={curRole === 'BD'}>{(curRole === 'PA' || curRole === 'PMA') ? '项目管理员' : 'BD'}</Text>
                                    </Col>
                                    <Col span={1} />
                                    <Col span={16}>
                                        <div style={{ marginTop: 10 }} className="select-gay">
                                            {this.getPASource()}
                                        </div>
                                    </Col>
                                </Row>
                                {(curRole === 'PA' || curRole === 'PMA') &&
                                    <Row>
                                        <Col span={6} style={{ marginTop: 10 }}>
                                            <Text>{'协助项目成员'}</Text>
                                        </Col>
                                        <Col span={1} />
                                        <Col span={16}>
                                            <div style={{ marginTop: 10 }} className="select-gay">
                                                {this.getPMASource()}
                                            </div>
                                        </Col>
                                    </Row>
                                }
                            </div>
                            <div className="setrole_add" style={{ borderTop: "none", height: "50px" }}>
                                {(curRole === 'PA' || curRole === 'PMA') &&
                                    <Row>
                                        <Col span={6} style={{ marginTop: 10 }}>添加人员：</Col>
                                        <Col span={1} />
                                        <Col span={16}>
                                            <div style={{ marginTop: 10 }} className="select-gay">
                                                <RadioGroup onChange={this.onAddRoleChange} value={curRole}>
                                                    <Radio value="PA">项目管理员</Radio>
                                                    <Radio value="PMA">协助项目成员</Radio>
                                                </RadioGroup>
                                            </div>
                                        </Col>
                                    </Row>
                                }
                                <Row>
                                    <Col span={6} style={{ marginTop: 10 }}></Col>
                                    <Col span={1} />
                                    <Col span={16}>
                                        <div className="select-gay">
                                            {
                                                !rerender ?
                                                    <InputGroup compact>
                                                        <UserSearchInput style={{ width: 130, marginBottom: 10 }}
                                                            handleSelectUser={this.handleSelectUser}
                                                            url={`${API_URL.team.userlist}`}
                                                            placeholder="工号或姓名"
                                                            searchKey='keyword'
                                                            dropdownClassName="user-auto-search"
                                                            dropdownAlign={{
                                                                points: ['bl', 'tl'], // align dropdown bottom-left to top-left of input element
                                                                offset: [0, -4], // align offset
                                                                overflow: {
                                                                    adjustX: 0,
                                                                    adjustY: 0, // do not auto flip in y-axis
                                                                },
                                                            }}
                                                        />
                                                        <Button style={{ marginBottom: 10 }} type="Default" onClick={this.moreUser}>更多</Button>
                                                    </InputGroup>
                                                    :
                                                    null
                                            }

                                            <Button style={{ display: 'inline-block', marginBottom: 10, marginLeft: 20, marginTop: 10 }} type="primary" onClick={this.onAddUser}>添加</Button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        <UserDetail ref={el => { this.userDetailRef = el; }} />
                    </Spin>
                </Modal>
                <MoreConditionUser ref={el => { this.moreUserRef = el; }} addFromCondition={this.addFromCondition} />
                <TransferPro
                    ref={el => { this.transferProRef = el; }}
                    investigationName={investigation.investigationName}
                    investigationCode={investigation.investigationCode}
                    investigationId={investigationId}
                    loadData={this.loadModalData} />
            </div>
        )
    }
}

export default SetPA;


// WEBPACK FOOTER //
// ./src/components/investigation/SetPA.js